import { render, staticRenderFns } from "./DebtorsTable.vue?vue&type=template&id=73152209&scoped=true&"
import script from "./DebtorsTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DebtorsTable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DebtorsTable.vue?vue&type=style&index=0&id=73152209&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73152209",
  null
  
)

export default component.exports